import api from '../../../core/api/api';

export const rolesAPI = {
  getRoles: async () => {
    try {
      const response = await api.get('/Roles/ListarRoles');
      return response.data;
    } catch (error) {
      console.error('Error al obtener roles:', error);
      throw error;
    }
  },

  getEstadosTurno: async () => {
    try {
      const response = await api.get('/EstadosTurno/ListarEstadosTurno');
      return response.data;
    } catch (error) {
      console.error('Error al obtener estados de turno:', error);
      throw error;
    }
  },

  getMenus: async () => {
    try {
      const response = await api.get('/Menus/ListarMenus');
      return response.data;
    } catch (error) {
      console.error('Error al obtener menús:', error);
      throw error;
    }
  },

  updatePermisos: async (rolId, estadosPermitidos) => {
    try {
      const response = await api.put(`/Roles/ActualizarPermisos/${rolId}`, {
        estadosPermitidos
      });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar permisos:', error);
      throw error;
    }
  },

  updatePermisosMenus: async (rolId, menusPermitidos) => {
    try {
      const response = await api.put(`/Roles/ActualizarPermisosMenus/${rolId}`, {
        menusPermitidos
      });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar permisos de menús:', error);
      throw error;
    }
  }
};
